import { Box } from '@material-ui/core';
import { Captions } from 'components/Typography';
import styled from 'styled-components';

export const StyledCaptions = styled(Captions)`
  padding: 10px 70px;
  text-align: center;
`;

export const WrapperBox = styled(Box)<{ matches: boolean }>`
  margin: ${({ matches }) => (matches ? '0 20px' : '0 96px')};
  border: 1px solid #e3e3e3 !important;
  border-radius: 4px;
  padding: 8px;
  margin-bottom: 16px;
`;
